"use client";

import { useEffect, useState } from "react";
import { Cart } from "@cappelendamm/e-commerce-services";
import { getLongHorizonPreorderSkus } from "@/products/selectors/getLongHorizonPreorderSkus";

export function usePreorderSkus(cart: Cart | null): Set<string> {
  const [preorderSkus, setPreorderSkus] = useState<Set<string>>(new Set());

  const cartSkus = cart?.items.map((item) => item.variant.sku).join(",") ?? "";

  useEffect(() => {
    let cancelled = false;

    if (!cartSkus) {
      setPreorderSkus(new Set());
      return;
    }

    const skus = cartSkus.split(",");
    void getLongHorizonPreorderSkus({ skus }).then((result) => {
      if (!cancelled) setPreorderSkus(new Set(result));
    });

    return () => {
      cancelled = true;
    };
  }, [cartSkus]);

  return preorderSkus;
}
